import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "De basisindeling van uw nieuwbouwwoning staat vastgelegd in de verkoopbrochure en de technische omschrijving. Het kan natuurlijk zo zijn, dat deze indeling niet geheel aansluit op uw ideeën over een praktische inrichting.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "U kunt de basisindeling van uw badkamer en toiletruimte nog aanpassen naar uw woonwensen door te kiezen voor inrichten of casco. Als u kiest voor het inrichten van uw badkamer en toiletruimte, dan is deze direct gebruiksklaar. Hierdoor kan de woning eerder in gebruik worden genomen. Uw badkamer en toiletruimte worden standaard ingericht met sanitair van het merk Villeroy & Boch en hoogwaardige kranen van het merk Grohe. Kiest u voor het inrichten van uw badkamer en toiletruimte, dan worden alle inrichtingsmogelijkheden aan u getoond.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Kiest u voor een casco oplevering, dan houdt dit in dat alleen de elektra en het mv-punt aanwezig zijn. De leidingen worden afgedopt op de standaard posities. De inrichtingsmogelijkheden op het gebied van sanitair worden dan ook niet aan u getoond.", -1)

import { computed, onMounted } from 'vue'
import { generalStore } from '@/stores/general'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { completion1Store } from '@/stores/v2/completion1'
import WoononSubtotalWidget from '@/components/v2/subtotal/WoononSubtotalWidget.vue'
import WoononSubtotalMobileWidget from '@/components/v2/subtotal/WoononSubtotalMobileWidget.vue'
import WoononCompletionOneProductsDesktop from '@/components/v2/completion1/WoononCompletionOneProductsDesktop.vue'
import WoononPhaseStateMessages from '@/components/v2/WoononPhaseStateMessages.vue'
import WoononCompletionOneProductsMobile from '@/components/v2/completion1/WoononCompletionOneProductsMobile.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion1',
  setup(__props) {

const showProducts = computed(() => !['loading', 'test'].includes(completion1Store().phaseState) || authStore().isInternalDemoAccount)

onMounted(() => {
  completion1Store().getPhaseState()
  completion1Store().getCompletion1Products()
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "completion1",
    gutter: [16,4]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Afbouw 1 - Indelingskeuzes",
            loading: _unref(completion1Store)().loading
          }, {
            default: _withCtx(() => [
              _createVNode(WoononPhaseStateMessages, {
                phaseState: _unref(completion1Store)().phaseState,
                orderReceived: _unref(headerStore)().ordersReceived.completion
              }, null, 8, ["phaseState", "orderReceived"]),
              (_unref(showProducts))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_1,
                            _hoisted_2,
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider),
                    (_unref(generalStore)().desktop)
                      ? (_openBlock(), _createBlock(WoononCompletionOneProductsDesktop, { key: 0 }))
                      : (_openBlock(), _createBlock(WoononCompletionOneProductsMobile, { key: 1 }))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(WoononSubtotalWidget)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(WoononSubtotalMobileWidget, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})